import React, { useState } from 'react'
import PropTypes from 'prop-types'
import IntersectionVisible from 'react-intersection-visible'
import {
  FormContainerStyled,
  AnimatedBorderContainer,
  FormHeaderContainerStyled,
  StyledTitle,
  StyledBody,
  FormStyled,
  FormLabel,
  FormGroup,
  FormInput,
  SelectGroup,
  SelectedOption,
  SelectOptions,
  SelectOption,
  FormTextarea,
  SubmitButton,
  FormContent,
} from './styles'
import axios from 'axios'

const FormContainer = props => {
  const {
    email_input_label,
    email_input_placeholder,
    first_name_input_label,
    first_name_input_placeholder,
    form_body,
    form_title,
    last_name_input_label,
    last_name_input_placeholder,
    select_label,
    select_options,
    submit_button,
    textarea_placeholder,
    success_message,
  } = props
  const [isVisible, setIsVisible] = useState(false)
  const [state, setState] = useState({
    firstname: '',
    lastname: '',
    email: '',
    service_of_interest: select_options?.[0]?.option?.text,
    message: '',
  })
  const [success, setSuccess] = useState(false)
  const [showList, setShowList] = useState(false)

  const formData = {
    fields: [
      {
        name: 'firstname',
        value: state.firstname,
      },
      {
        name: 'lastname',
        value: state.lastname,
      },
      {
        name: 'email',
        value: state.email,
      },
      {
        name: 'service_of_interest',
        value: state.service_of_interest,
      },
      {
        name: 'message',
        value: state.message,
      },
    ],
  }

  const changeHandler = e => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    })
  }

  const submitHandler = async e => {
    e.preventDefault()
    await axios.request({
      method: 'post',
      url:
        'https://api.hsforms.com/submissions/v3/integration/submit/6622300/55b16a57-373e-424d-8d4a-e419ecf0b24c',
      headers: { 'Content-Type': 'application/json' },
      data: JSON.stringify(formData),
    })

    setSuccess(true)

    setTimeout(() => {
      setSuccess(false)
    }, 3000)
  }

  const { firstname, lastname, email, service_of_interest, message } = state

  const isInvalid =
    firstname === '' ||
    lastname === '' ||
    email === '' ||
    service_of_interest === '' ||
    service_of_interest === select_options[0]?.option.text
  message === '' || success

  return form_title?.text && form_body?.text ? (
    <IntersectionVisible
      onShow={() => setIsVisible(true)}
      onHide={() => setIsVisible(false)}
    >
      <FormContainerStyled>
        <FormContent>
          <FormHeaderContainerStyled>
            <StyledTitle as="h3" type="h3">
              {form_title?.text}
            </StyledTitle>
          </FormHeaderContainerStyled>
          <AnimatedBorderContainer isVisible={isVisible}>
            <StyledBody>{form_body?.text}</StyledBody>
            <FormStyled
              id="hs-form-55b16a57-373e-424d-8d4a-e419ecf0b24c-bdc0e815-ec2a-4302-a722-baadea826dc9"
              onSubmit={submitHandler}
            >
              {first_name_input_label?.text &&
              first_name_input_placeholder?.text ? (
                <FormGroup>
                  <FormLabel id="firstname-label" htmlFor="firstname-input">
                    {first_name_input_label.text}
                  </FormLabel>
                  <FormInput
                    id="firstname-input"
                    aria-labelledby="firstname-label"
                    name="firstname"
                    placeholder={first_name_input_placeholder.text}
                    type="text"
                    onChange={changeHandler}
                    required
                  />
                </FormGroup>
              ) : (
                <></>
              )}
              {last_name_input_label?.text &&
              last_name_input_placeholder?.text ? (
                <FormGroup>
                  <FormLabel id="lastname-label" htmlFor="lastname-input">
                    {last_name_input_label.text}
                  </FormLabel>
                  <FormInput
                    id="lastname-input"
                    aria-labelledby="lastname-label"
                    name="lastname"
                    placeholder={last_name_input_placeholder.text}
                    type="text"
                    onChange={changeHandler}
                    required
                  />
                </FormGroup>
              ) : (
                <></>
              )}
              {select_label?.text && select_options?.length > 0 ? (
                <SelectGroup showList={showList}>
                  <FormLabel
                    id="service_of_interest-label"
                    htmlFor="service_of_interest-input"
                  >
                    {select_label.text}
                  </FormLabel>
                  <SelectedOption
                    onClick={() => setShowList(!showList)}
                    id="service_of_interest-input"
                    name="service_of_interest"
                    defaultValue={state.service_of_interest}
                    required
                  >
                    <option disabled>{state.service_of_interest}</option>
                  </SelectedOption>
                  <SelectOptions showList={showList}>
                    {select_options
                      .slice(1, select_options.length)
                      .map(({ option }, index) => {
                        return (
                          <SelectOption
                            onClick={e => {
                              setState({
                                ...state,
                                service_of_interest: e.target.innerText,
                              })
                              setShowList(!showList)
                            }}
                            key={`${option.text}--${index}`}
                          >
                            {option.text}
                          </SelectOption>
                        )
                      })}
                  </SelectOptions>
                </SelectGroup>
              ) : (
                <></>
              )}
              {email_input_label?.text && email_input_placeholder?.text ? (
                <FormGroup>
                  <FormLabel id="email-label" htmlFor="email-input">
                    {email_input_label.text}
                  </FormLabel>
                  <FormInput
                    id="email-input"
                    aria-labelledby="email-label"
                    name="email"
                    placeholder={email_input_placeholder.text}
                    type="email"
                    onChange={changeHandler}
                    required
                  />
                </FormGroup>
              ) : (
                <></>
              )}
              <FormTextarea
                onChange={changeHandler}
                name="message"
                required
                placeholder={textarea_placeholder?.text}
              />
              <SubmitButton
                disabled={isInvalid}
                buttonStyle="primary"
                type="submit"
              >
                {success ? success_message?.text : submit_button?.text}
              </SubmitButton>
            </FormStyled>
          </AnimatedBorderContainer>
        </FormContent>
      </FormContainerStyled>
    </IntersectionVisible>
  ) : (
    <></>
  )
}

FormContainer.propTypes = {
  query: PropTypes.object.isRequired,
}

export default FormContainer
